// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blSZ{display:flex;flex-direction:column;gap:16px;padding:24px;width:100%}._327e{display:inline-flex;font-family:\"Roboto\",sans-serif!important;font-size:16px;font-style:normal;font-weight:700;letter-spacing:.15px;line-height:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PWAsideBodyItem": "blSZ",
	"PWAsideBodyItemHeader": "_327e"
};
module.exports = ___CSS_LOADER_EXPORT___;
